export { type UseFocusTrapProps, useFocusTrap } from './useFocusTrap';
